import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Card, CardContent } from '@/components/ui/card';
import { Briefcase, Wrench, Handshake, Star } from 'lucide-react';
import { getImageAssetPath } from '@/lib/imageHelper';

const FoundersSectionBlock = () => {
  const ddiImagePath = getImageAssetPath('ddi.jpeg');
  const sbrImagePath = getImageAssetPath('sbr.jpeg');

  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-blue-50 to-gray-50">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Die Gründer hinter splusd</h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Wir bringen unterschiedliche Expertisen und Perspektiven zusammen, um Ihr Unternehmen digital voranzubringen.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* Dennis Dittrich */}
          <Card className="border-none shadow-lg">
            <CardContent className="p-6">
              <div className="flex flex-col items-center md:items-start md:flex-row gap-6">
                <Avatar className="w-24 h-24 border-2 border-orange-200">
                  <AvatarImage src={ddiImagePath} alt="Dennis Dittrich" />
                  <AvatarFallback className="bg-orange-100 text-orange-700 text-xl font-bold">DD</AvatarFallback>
                </Avatar>
                <div>
                  <h3 className="text-2xl font-bold mb-2">Dennis Dittrich</h3>
                  <p className="text-gray-600 mb-4 flex items-center">
                    <Briefcase className="w-4 h-4 mr-2 text-orange-500" />
                    Software-Entwicklung Experte
                  </p>
                  <p className="text-gray-700">
                    Mit über 10 Jahren Erfahrung als freiberuflicher Software-Entwickler hat Dennis ein breites Spektrum an Projekten realisiert – 
                    von Webseiten und E-Commerce-Plattformen bis hin zu komplexen CRM-Systemen. Durch eigene Software-Projekte versteht er 
                    auch die Herausforderungen aus unternehmerischer Perspektive.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
          
          {/* Simon Brüggemann */}
          <Card className="border-none shadow-lg">
            <CardContent className="p-6">
              <div className="flex flex-col items-center md:items-start md:flex-row gap-6">
                <Avatar className="w-24 h-24 border-2 border-blue-200">
                  <AvatarImage src={sbrImagePath} alt="Simon Brüggemann" />
                  <AvatarFallback className="bg-blue-100 text-blue-700 text-xl font-bold">SB</AvatarFallback>
                </Avatar>
                <div>
                  <h3 className="text-2xl font-bold mb-2">Simon Brüggemann</h3>
                  <p className="text-gray-600 mb-4 flex items-center">
                    <Wrench className="w-4 h-4 mr-2 text-blue-500" />
                    IT-System & Transformations Spezialist
                  </p>
                  <p className="text-gray-700">
                    Als ehemaliger Systemadministrator und IT-Leiter in einem mittelständischen Unternehmen
                    kennt Simon die Herausforderungen der digitalen Transformation aus erster Hand. Er weiß, 
                    wie man die richtigen Tools für ein Unternehmen identifiziert und erfolgreich implementiert.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
        
        {/* Gemeinsame Vision */}
        <div className="bg-white rounded-xl shadow-lg p-8 max-w-4xl mx-auto">
          <h3 className="text-2xl font-bold mb-6 text-center">Unsere gemeinsame Vision</h3>
          
          <div className="grid md:grid-cols-2 gap-8 mb-6">
            <div className="flex flex-col items-center text-center">
              <div className="bg-orange-100 p-4 rounded-full mb-4">
                <Handshake className="w-8 h-8 text-orange-600" />
              </div>
              <h4 className="font-bold text-lg mb-2">360° Perspektive</h4>
              <p className="text-gray-700">
                Wir haben splusd gegründet, um Unternehmen mit unserem ganzheitlichen Blick aus Softwareentwicklung 
                und Systemadministration zu beraten. Diese Kombination ermöglicht maßgeschneiderte Lösungen.
              </p>
            </div>
            
            <div className="flex flex-col items-center text-center">
              <div className="bg-blue-100 p-4 rounded-full mb-4">
                <Star className="w-8 h-8 text-blue-600" />
              </div>
              <h4 className="font-bold text-lg mb-2">Individuelle Partnerschaften</h4>
              <p className="text-gray-700">
                Wir streben langfristige Partnerschaften an und tauchen tief in die Materie Ihres Unternehmens ein. 
                Jeder Kunde wird individuell betrachtet – wir sind keine "Fließband-Agentur".
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FoundersSectionBlock; 